const rocketbet = {
    themeName: 'rocketbet',
    brand: 'Rocketbet',
    font: {
        main: ['Montserrat', 'sans-serif'],
        alternative: ['Inter', 'sans-serif'],
        'alternative-2': ['Montserrat', 'sans-serif'],
        'alternative-3': ['Montserrat', 'sans-serif']
    },
    color: {
        primary: {
            '100': '#378cfa80',
            '300': '#2365DE',
            '500': '#006FFF',
            '700': '#0f44a6',
            '900': '#002D7D'
        },
        secondary: {
            '100': '#CEE0F4',
            '300': '#2282FF',
            '500': '#006FFF',
            '700': '#004fb5',
            '900': '#003880'
        },
        tertiary: {
            '100': '#2D518B',
            '300': '#2b416d',
            '500': '#182644',
            '700': '#13264c',
            '900': '#00091B'
        },
        accent: {
            '100': '#35C698',
            '300': '#00fa33',
            '500': '#00B625',
            '700': '#008f1d',
            '900': '#006D16'
        },
        neutral: {
            '100': 'transparent',
            '300': '#FFFFFF1A',
            '500': '#FFFFFF33',
            '700': '#FFFFFF4D',
            '900': '#FFFFFF66'
        },
        background: {
            '100': '#182644',
            '300': '#182644',
            '500': '#182644',
            '700': '#0D1930',
            '900': '#00091B'
        },
        success: {
            '100': '#4dfa71',
            '300': '#00fa33',
            '500': '#00B625',
            '700': '#008f1d',
            '900': '#016916'
        },
        warning: {
            '100': '#FFE5B0',
            '300': '#FFC266',
            '500': '#F8A73C',
            '700': '#E27625',
            '900': '#7C3F00'
        },
        error: {
            '100': '#fa7888',
            '300': '#fa5c70',
            '500': '#F83C53',
            '700': '#f70220',
            '900': '#bd0219'
        },
        info: {
            '100': '#b8fcfc',
            '300': '#90fcfc',
            '500': '#66FFFF',
            '700': '#2ac7c7',
            '900': '#068c8c'
        },
        text: {
            '100': '#FFFFFF',
            '300': '#B4B4C5',
            '500': '#6D6F8A',
            '700': '#343A49',
            '900': '#000000'
        },
        highlight: { '1': '#006FFF', '2': '#66FFFF', '3': '#FFC857', '4': '#0EC4FF', '5': '#66FFFF' }
    },
    gradients: {
        main: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.tertiary.500', at: '0%' },
                { token: 'color.background.100', at: '100%' }
            ]
        },
        alternative: {
            type: 'linear',
            angle: '300deg',
            stops: [
                { token: 'color.neutral.300', at: '0%' },
                { token: 'color.neutral.100', at: '100%' }
            ]
        },
        'alternative-2': {
            type: 'raw',
            css: 'radial-gradient(81.25% 35.57% at 50% -16.3%, var(--color-neutral-500) 0%, var(--color-neutral-100) 100%), radial-gradient(79.71% 101.56% at 21.62% 50.54%, var(--color-neutral-100) 0%, var(--color-neutral-300) 100%)'
        },
        'alternative-3': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.900', at: '0%' },
                { token: 'color.background.500', at: '100%' }
            ]
        },
        'alternative-4': {
            type: 'linear',
            angle: '179.7deg',
            stops: [
                { token: 'color.background.700', at: '0%' },
                { token: 'color.background.900', at: '100%' }
            ]
        },
        'alternative-5': {
            type: 'raw',
            css: 'radial-gradient(100% 150% at 0% 50%, transparent 0%, var(--color-neutral-300) 100%)'
        },
        'alternative-6': {
            type: 'raw',
            css: 'radial-gradient(100% 150% at 0% 50%, transparent 0%, var(--color-neutral-500) 100%)'
        },
        primary: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.neutral.100', at: '0%' },
                { token: 'color.neutral.100', at: '50%' },
                { token: 'color.primary.500', at: '100%' }
            ]
        },
        'primary-2': {
            type: 'raw',
            css: 'linear-gradient(180deg, var(--color-neutral-100) 3.43%, var(--color-primary-500) 99.45%), radial-gradient(101.56% 79.71% at 21.62% 50.54%, var(--color-neutral-100) 0%, var(--color-neutral-300) 100%), radial-gradient(35.59% 81.32% at 50% -16.3%, var(--color-neutral-500) 0%, var(--color-neutral-100) 100%), rgba(255, 255, 255, 0.15)'
        },
        'primary-dark': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.500', at: '0%' },
                { token: 'color.primary.900', at: '100%' }
            ]
        },
        secondary: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.neutral.100', at: '0%' },
                { token: 'color.neutral.100', at: '50%' },
                { token: 'color.secondary.500', at: '100%' }
            ]
        },
        'secondary-light': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.secondary.300', at: '0%' },
                { token: 'color.secondary.500', at: '100%' }
            ]
        },
        'progress-fill': {
            type: 'linear',
            angle: '90deg',
            stops: [
                { token: 'color.primary.500', at: '0%' },
                { token: 'color.highlight.5', at: '100%' }
            ]
        },
        'progress-fill-2': {
            type: 'linear',
            angle: '90deg',
            stops: [
                { token: 'color.background.100', at: '0%' },
                { token: 'color.primary.500', at: '100%' }
            ]
        },
        tertiary: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.neutral.100', at: '0%' },
                { token: 'color.neutral.100', at: '50%' },
                { token: 'color.tertiary.500', at: '100%' }
            ]
        },
        accent: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.neutral.100', at: '0%' },
                { token: 'color.neutral.100', at: '50%' },
                { token: 'color.accent.500', at: '100%' }
            ]
        },
        success: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.success.500', at: '0%' },
                { token: 'color.success.900', at: '100%' }
            ]
        },
        error: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.error.500', at: '0%' },
                { token: 'color.error.700', at: '100%' }
            ]
        },
        'error-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.error.300', at: '0%' },
                { token: 'color.error.700', at: '100%' }
            ]
        },
        christmas: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'christmas.2', at: '0%' },
                { token: 'christmas.1', at: '100%' }
            ]
        },
        'christmas-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'christmas.3', at: '0%' },
                { token: 'christmas.4', at: '100%' }
            ]
        }
    },
    borderRadius: {
        button: { default: '12px', small: '8px' },
        input: { default: '30px', message: '8px' },
        header: { chatNotifications: '8px', profile: '8px', toggle: '8px', vip: '8px' },
        promotions: { item: '8px' }
    },
    components: {
        error: { background: 'color.error.500', text: 'color.text.100' },
        footer: { social: 'transparent' },
        info: { background: 'color.info.500', text: 'color.text.900' },
        input: {
            background: 'color.background.900',
            border: 'color.neutral.300',
            'border-hover': 'color.primary.500',
            'border-active': 'color.primary.500'
        },
        progress: {
            background: 'color.background.900',
            'background-2': 'color.background.900',
            fill: 'gradient.progress-fill',
            'fill-2': 'gradient.progress-fill-2',
            'fill-2-shadow': 'color.primary.500',
            'fill-shadow': 'color.primary.500'
        },
        success: { background: 'color.success.500', text: 'color.text.100' },
        table: { 'odd-row': 'color.neutral.300' },
        warning: { background: 'color.warning.500', text: 'color.text.900' }
    },
    boxShadows: {
        neutral: 'inset 0 -6px 10px rgba(255,255,255,.45), inset 0  6px 12px rgba(0,0,0,.28), 0 4px 12px rgba(0,0,0,.18)',
        inner: 'none',
        vip: '0px 0px 8px 0px #ffffff7a'
    },
    maxHeight: { zero: '0', full: '100%' },
    transitions: { maxHeight: 'max-height', rotate: 'transform' },
    rotate: { '360': '360deg' },
    width: { fitContent: 'fit-content', width15: '3.70rem', chatWidth: '340px' },
    height: { height15: '3.70rem' },
    screens: { xs390: '390px', customSm: '580px', custom720: '720px' },
    // Each step reuses Rocketbet's own closest-toned token (dark red -> error.900, bright red ->
    // error.300, gold -> highlight.3, orange -> warning.500/300, brown -> warning.900, deep blue ->
    // primary.900, green -> accent.900, frost blue -> secondary.300) instead of Flush's literal
    // christmas hex values.
    christmas: {
        '1': '#bd0219',
        '2': '#fa5c70',
        '3': '#FFC857',
        '4': '#F8A73C',
        '5': '#7C3F00',
        '6': '#FFC266',
        '7': '#002D7D',
        '8': '#FFFFFF',
        '9': '#006D16',
        '10': '#2282FF'
    },
    vip: { '1': '#4F11DD', '2': '#120532' }
};
export default rocketbet;
